import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";

import { parseInputs } from "./parseInputs";
import { generateBaseSchedule } from "./scheduleGenerator";
import { applyPaymentsToSchedule } from "./paymentApplier";
import { recalculateAbono } from "./abonoRecalculator";
import { mergeWithExistingPayments } from "./helpers";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export function planPagos(data, investorRate) {
  const {
    loanAmount,
    annualRate,
    monthlyRate,
    loanTerm,
    startDate,
    payments,
    paymentsInvestor,
    abonos,
  } = parseInputs(data, investorRate);

  const monthlyPayment =
    loanAmount * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -loanTerm)));

  const { schedule: baseSchedule, totalInterest } = generateBaseSchedule({
    loanAmount,
    monthlyRate,
    loanTerm,
    startDate,
    monthlyPayment,
  });

  const totalCredit = Number(totalInterest) + Number(data?.ammount);
  const scheduleWithPayments = applyPaymentsToSchedule(baseSchedule, payments);
  const scheduleWithPaymentsInvestor = applyPaymentsToSchedule(
    baseSchedule,
    paymentsInvestor
  );

  const ultimoAbono = abonos[abonos.length - 1];
  const antesUltimoAbono = abonos[abonos.length - 2] ?? null;

  const pagosHechos = payments.length;

  if (
    !ultimoAbono ||
    !["mantener", "recalcular", "recalculo_plazo"].includes(ultimoAbono.type)
  ) {
    return {
      schedule: investorRate
        ? scheduleWithPaymentsInvestor
        : scheduleWithPayments,
      totalInterest,
      totalCredit,
      payments,
      planVersion: 1,
    };
  }
  if (ultimoAbono && pagosHechos > 0) {
    const { nuevoSchedule, nuevoPlanVersion } = recalculateAbono({
      ultimoAbono,
      antesUltimoAbono,
      scheduleWithPayments: investorRate
        ? scheduleWithPaymentsInvestor
        : scheduleWithPayments,
      pagosHechos,
      monthlyRate,
      monthlyPayment,
      startDate,
    });

    const finalSchedule = mergeWithExistingPayments(
      nuevoSchedule,
      investorRate ? scheduleWithPaymentsInvestor : scheduleWithPayments
    );

    return {
      schedule: finalSchedule,
      totalInterest,
      totalCredit,
      payments: payments.map((p) => ({
        ...p,
        planVersion: p.planVersion || 1,
      })),
      planVersion: nuevoPlanVersion,
    };
  }

  return {
    schedule: scheduleWithPayments,
    totalInterest,
    totalCredit,
    payments,
    planVersion: ultimoAbono.planVersion ?? 1,
  };
}
